import { LessonStep } from '../../main/types/asset/lesson.types.ts';

const DEFAULT_STEP_DETAILS = 'No current step';
const DEFAULT_VALUE = 'None';

export const mapStepDetails = (step?: LessonStep): string => {
  if (!step) {
    return DEFAULT_STEP_DETAILS;
  }

  return `
    Step Type: ${step.stepType}
    Script Key: ${step.scriptKey ?? DEFAULT_VALUE}
    Question: ${step.question ?? DEFAULT_VALUE}
    Content: ${step.content ?? DEFAULT_VALUE}
    Target: ${step.target ?? DEFAULT_VALUE}
    Answer: ${step.answer ?? DEFAULT_VALUE}
    Parts: ${step.parts?.join(', ') ?? DEFAULT_VALUE}
  `;
};
